type ParamVerdi = string | Array<string> | undefined;

const harVerdi = (verdi: ParamVerdi) =>
    Array.isArray(verdi) ? verdi.length > 0 : !!verdi?.trim();

const utenTommeVerdier = <P extends Record<string, ParamVerdi>>(
    params: P,
): Partial<P> =>
    Object.fromEntries(
        Object.entries(params)
            .filter(([, verdi]) => harVerdi(verdi))
            .map(([navn, verdi]) => [
                navn,
                typeof verdi === 'string' ? verdi.trim() : verdi,
            ]),
    ) as Partial<P>;

/**
 * Query params for a list view, with only the filters that narrow the list.
 * «Alle», no selection and empty fields are left out.
 *
 * A search is sent alone, without the filters, so it always searches the whole
 * list and not just a filtered part of it.
 */
export const getListParams = <
    F extends Record<string, ParamVerdi>,
    S extends Record<string, string | undefined>,
>(
    filtre: F,
    sok: S,
): Partial<F> | Partial<S> => {
    const sokParams = utenTommeVerdier(sok);
    return Object.keys(sokParams).length > 0
        ? sokParams
        : utenTommeVerdier(filtre);
};

/**
 * The selected statuses to filter on. Every status selected is the same as
 * none selected, so both give undefined.
 */
export const getAktiveStatuser = (
    valgte: Array<string>,
    alle?: Array<string>,
): Array<string> | undefined => {
    const alleValgt =
        !!alle?.length && alle.every((status) => valgte.includes(status));
    return valgte.length > 0 && !alleValgt ? valgte : undefined;
};

/**
 * Whether a filter or a search narrows the list. List endpoints without paging
 * should only be called when one does.
 */
export const harAktivtFilter = (params: object) =>
    Object.keys(params).length > 0;
